import { render, staticRenderFns } from "./RecentSales.vue?vue&type=template&id=486beae1&scoped=true&"
import script from "./RecentSales.vue?vue&type=script&lang=js&"
export * from "./RecentSales.vue?vue&type=script&lang=js&"
import style0 from "./RecentSales.vue?vue&type=style&index=0&id=486beae1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486beae1",
  null
  
)

export default component.exports